import { render, staticRenderFns } from "./AttachmentUploadConfigs.vue?vue&type=template&id=f03d0f22&"
import script from "./AttachmentUploadConfigs.vue?vue&type=script&lang=js&"
export * from "./AttachmentUploadConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports